const BASE_URL = "https://apideclass.yamminelawfirm.com/api";
// const BASE_URL = "http://localhost:5001/api";

export const FRONTEND_URL = "https://declass.yamminelawfirm.com";
// export const FRONTEND_URL = "http://localhost:3001";

export default BASE_URL;
